import { Dispatch } from "redux";
import { ApiConfig } from "../../../../../../config/ApiConfig";
import { Collection } from "../../../../../../models";
import { MoveItemLaneRequest } from "../../../../../../models/MoveLaneRequest";
import { createRequestActionTypes } from "../../../../../../utils/request-actions-helpers/createRequestActionTypes";
import { createRequestThunk, RequestThunkParameters } from "../../../../../../utils/request-actions-helpers/createRequestThunk";
import { AppStateWithData } from "../../../../../AppStateWithData";

export const moveDocumentSuccessLaneActionTypes = createRequestActionTypes('MOVE_DOCUMENT_SUCCESS_LANE')

type _ApiConfig = ApiConfig & { onWithRules?: () => void }
export const moveDocumentSuccessLane = (config: _ApiConfig) => (itemMoveRequest: MoveItemLaneRequest) => (dispatch: Dispatch, getState: () => AppStateWithData) => {
    const thunkParams: RequestThunkParameters<Collection, MoveItemLaneRequest> = {
        method: 'PUT',
        url: `${config.API_URL}/collections/moveCardToSuccess/`,
        requestActionTypes: moveDocumentSuccessLaneActionTypes,

        body: itemMoveRequest,
        processResultBeforeDispatch: (result: Collection) => {
            if (config.refreshFeed) {
                config.refreshFeed()
            }
            if (config.updateItem) {
                config.updateItem(itemMoveRequest.cardId)
            }
            if(!!config.onWithRules) {
                setTimeout(() => {
                    config.onWithRules?.()
                }, 350)
            }
            return result
        }
    }

    return dispatch<any>(createRequestThunk(thunkParams))
}